<div class="container my-4 contactContent" id="">
  <h3 class="page-title" *ngIf="!hideAddressHeader">{{'ContactAssessor.TitleGeneral'|translate}}</h3>
  <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
  <hr>
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">
        <div class="form-group col-md-6" style="display: flex; flex-direction: column; align-items: center; width: 49%;">

          <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="First">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{'ContactAssessor.Required'|translate}}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="Last">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('lastName', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>
      <div class="form-group">
        <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
        <input type="email" class="form-control" formControlName="email" placeholder="Email">
        <div class="invalid-feedback" style="display: block">
          @if (hasError('email', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>
      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
      <div class="form-row">
        <div class="form-group col-12">
          <input class="form-control"  type="text" appPhoneMask  formControlName="phone" id="inputPhone-General" placeholder="{{'ContactAssessor.Phone' | translate}}" >
          <div class="invalid-feedback" style="display: block">
            @if (hasError('phone', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>

      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Description' | translate}}</p>
      <div class="form-group">

        <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4" placeholder="Type here"></textarea>
      </div>
      <p class="form-label" style="margin-top: 15px;">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
      <div class="form-group" style="margin-top: 15px;">
        <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('file', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
          @if (hasError('file', 'requiredFileType')) {
            Only PDF, Docx
          }
          @if (hasError('file', 'requiredFileSize')) {
            Size to exceeds 10 MB
          }
        </div>
      </div>
      <div class="form-group" style="margin-top: 15px;">
        <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('recaptchaReactive', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>

      <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px;">Submit</button>@if (success) {
      <span>Successfully Submitted</span>
    }

  </form>

</div>
